var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-info mb-0"},[_c('icon',{staticClass:"mr-2 icon-baseline",attrs:{"icon":"fa-solid fa-info-circle"}}),_vm._v(_vm._s(_vm.restaurant.banner))],1)}
var staticRenderFns = []

export { render, staticRenderFns }